<nav class="lang-switcher" aria-label="Language">
    <a
        [href]="href('en')"
        class="lang"
        [class.active]="currentLang === 'en'"
        (click)="preventIfActive($event, 'en')"
    >EN</a>

    <span class="divider">|</span>

    <a
        [href]="href('es')"
        class="lang"
        [class.active]="currentLang === 'es'"
        (click)="preventIfActive($event, 'es')"
    >ES</a>
</nav>
